import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { OscConfiguration } from '../models/osc-configuration';
import { OscPlatform } from '../enums/osc-platform';
import { AppConfiguration } from '../interfaces/app-configuration';


@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private oscConfiguration: OscConfiguration;
  private appConfiguration: AppConfiguration;

  public constructor(public httpClient: HttpClient, @Optional() @Inject('PLATFORM') private oscPlatform?: OscPlatform) {
    this.oscPlatform = oscPlatform ? oscPlatform : OscPlatform.Web;
  }

  public load(path: string): Promise<AppConfiguration> {
    return this.httpClient.get<AppConfiguration>(path)
      .pipe(
        tap(response => {
          const { appStoreEndpointUrl,
            authenticationEndpointUrl,
            environmentName,
            myAppsEndpointUrl,
            myDevicesEndpointUrl,
            myDriveEndpointUrl,
            myAccountUrl,
            baseUrl,
            featureToggle,
            imsContentUrl,
            reportTemplateBuilderEndpointUrl,
            rootAppEndpointUrl,
            powerBiEndpointUrl,
            webApiUrl,
            ipmEndpointUrl
          } = response;

          this.oscConfiguration = {
            appStoreEndpointUrl,
            authenticationEndpointUrl,
            environmentName,
            myAppsEndpointUrl,
            myDevicesEndpointUrl,
            myDriveEndpointUrl,
            myAccountUrl,
            baseUrl,
            featureToggle,
            imsContentUrl,
            reportTemplateBuilderEndpointUrl,
            rootAppEndpointUrl,
            powerBiEndpointUrl,
            webApiUrl,
            ipmEndpointUrl
          };
        }
        ),
        tap(response => {
          this.appConfiguration = response;
        }),
        catchError(e => { console.log(`Error during load config file: ${JSON.stringify(e)}`); return null; })
      ).toPromise();
  }

  public getConfiguration(): OscConfiguration {
    return this.oscConfiguration;
  }

  public getAppConfiguration<T = any>(key: string): T {
    return this.appConfiguration[key];
  }

  public getPlatform(): OscPlatform {
    return this.oscPlatform;
  }

  public isWebApp(): boolean {
    return this.oscPlatform === OscPlatform.Web;
  }

  public isMobileApp(): boolean {
    return this.oscPlatform === OscPlatform.Android || this.oscPlatform === OscPlatform.IOs || this.oscPlatform === OscPlatform.Window;
  }
}
